/**
 * 获取DOM元素视口距离
 * @param element HTML元素
 */
export const getElementOffset = (
  element: HTMLElement
): { top: number; left: number; width: number; height: number } => {
  try {
    const rect = element.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    };
  } catch (_) {
    return {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
    };
  }
};
